import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'lp-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddButtonComponent extends BaseResizableComponent {
  @Input() title?: string;

  @Output() buttonClick = new EventEmitter();
}
